import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type JobScript,
  putProjectsProjectIDJobsJobIDScript,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useSaveJobScriptMutation(projectID: string, jobID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (script: JobScript) =>
        putProjectsProjectIDJobsJobIDScript(script, projectID, jobID),
      { translationPrefix: getResourcePath(Resources.ApiErrors.SaveJobScript) },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.jobDetail(projectID, jobID),
      });
    },
  });
}
